/**
 * Current published version of the legal terms (Terms of Service + Privacy
 * Policy). Bump this whenever the docs are materially updated, so each new
 * acceptance records exactly which version the user agreed to. Used by the
 * OAuth signup callbacks to stamp `users.acceptedTermsAt` / `acceptedTermsVersion`
 * when a new account is created via the click-through agreement on the login screen.
 */
// 2026-07-31: AI Act transparency additions to ToS §20, and the login screen
// sign-in-wrap now includes the 18+ age representation, so acceptances from
// this version onward double as the recorded age self-declaration.
export const CURRENT_LEGAL_VERSION = '2026-07-31';
